import { FirearmPoolService } from './firearm-pool.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { FIREARM_POOL_TYPE, FirearmPool } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class FirearmPoolResolverBase implements Resolve<FirearmPool> {

  constructor(protected service: FirearmPoolService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<FirearmPool> {
    const key: number = FIREARM_POOL_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



